import PropTypes from 'prop-types';
import moment from 'moment';
import { useRef } from 'react';
import MainLayout from '@/layout/MainLayout';
import CenterLayout from '@/layout/centerLayout/CenterLayout';
import pageProps from '@/layout/pageProps';
import ListNav from '@/components/pages/news/ListNav';
import { useStoriesList, useStoriesDetail } from '@/utils/hooks/news/useStoriesData';
import { getStoriesList } from '@/utils/api/SSRRequest';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';

import styles from '@/styles/pages/news/stories/index.module.scss';

function Page({ apiData }) {
  const router = useRouter();
  const { t, i18n } = useTranslation('pages', { keyPrefix: 'news.stories' });
  const contentRef = useRef(null);
  const id = router.query.id || apiData?.listData?.[0].id || '';
  const { data: detailData } = useStoriesDetail({ id });

  const detailObject = detailData || apiData.detailData || {};
  return (
    <MainLayout
      pageClassName={styles.pageContainer}
      headProps={{
        title: t('meta.title'),
        keyword: t('meta.keyword'),
        canonical: `https://www.bitop.com${i18n.language === 'en' ? '/en' : ''}/news/stories`,
      }}
    >
      <CenterLayout detail={detailObject}>
        <main className={styles.container}>
          {!router.query.id
            ? (
              <section className={styles.pageList}>
                {/* <div className={styles.title}>{t('header')}</div> */}
                <ListNav key={Date.now()} className={styles.listNav} defaultlist={apiData.listData} tab="/stories" listHook={useStoriesList} />
              </section>
            )
            : (
              <section className={styles.contents}>
                <article>
                  <h3 className={styles.title}>{detailObject?.title}</h3>
                  <h5 className={styles.time}>
                    {
                      i18n.language === 'en' ? moment(detailObject.date).format('[Published on] MMM Do, YYYY')
                        : moment(detailObject.date).format('YYYY年MM月DD日[发布]')
                    }
                  </h5>
                  {/* eslint-disable-next-line react/no-danger */}
                  <div ref={contentRef} className={styles.detail} dangerouslySetInnerHTML={{ __html: detailObject.content }} />
                </article>
              </section>
            )}
        </main>
      </CenterLayout>
    </MainLayout>
  );
}
export async function getServerSideProps(props) {
  const defaultProps = await pageProps(props);
  const { data: listData = null } = await getStoriesList({ lang: props.locale });
  return { props: { ...defaultProps, apiData: { listData } } };
}
Page.propTypes = {
  apiData: PropTypes.instanceOf(Object).isRequired,
};

export default Page;
